import React from 'react';
import { Calendar } from 'lucide-react';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Input } from '../ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

export const StatisticsFilters = ({
  groups = [],
  selectedGroupIds = ['all'],
  setSelectedGroupIds,
  period,
  setPeriod,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  displayDateRange,
  showGroupFilter = true
}) => {
  return (
    <div className="bg-white p-6 rounded-lg border border-zinc-200 mb-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Calendar className="h-5 w-5 text-zinc-600" />
          <h2 className="text-lg font-bold text-zinc-900">Hesabat Filtri</h2>
        </div>
        {displayDateRange && (
          <div className="flex items-center gap-2">
            {selectedGroupIds.length > 0 && !selectedGroupIds.includes('all') && (
              <div className="text-sm font-semibold text-amber-700 bg-amber-50 px-4 py-2 rounded-lg border border-amber-200">
                🏷️ {selectedGroupIds.length === 1 
                  ? groups.find(g => g.id === selectedGroupIds[0])?.name 
                  : `${selectedGroupIds.length} qrup seçildi`}
              </div>
            )}
            <div className="text-sm font-semibold text-primary bg-yellow-50 px-4 py-2 rounded-lg border border-yellow-200">
              📅 {displayDateRange}
            </div>
          </div>
        )}
      </div>
      
      <div className={`grid grid-cols-1 gap-4 ${showGroupFilter ? 'md:grid-cols-4' : 'md:grid-cols-3'}`}>
        {showGroupFilter && (
          <div>
            <Label htmlFor="group">Qrup / Ərazi</Label>
            <div className="mt-1.5 space-y-2">
              <div className="flex flex-wrap gap-2">
                <Button
                  type="button"
                  size="sm"
                  variant={selectedGroupIds.includes('all') ? 'default' : 'outline'}
                  onClick={() => setSelectedGroupIds(['all'])}
                  className={selectedGroupIds.includes('all') ? 'bg-amber-600' : ''}
                >
                  Hamısı
                </Button>
                {groups.map((group) => (
                  <Button
                    key={group.id}
                    type="button"
                    size="sm"
                    variant={selectedGroupIds.includes(group.id) ? 'default' : 'outline'}
                    onClick={() => {
                      if (selectedGroupIds.includes('all')) {
                        setSelectedGroupIds([group.id]);
                      } else if (selectedGroupIds.includes(group.id)) {
                        const newIds = selectedGroupIds.filter(id => id !== group.id);
                        setSelectedGroupIds(newIds.length === 0 ? ['all'] : newIds);
                      } else {
                        setSelectedGroupIds([...selectedGroupIds, group.id]);
                      }
                    }}
                    className={selectedGroupIds.includes(group.id) ? 'bg-amber-600' : ''}
                  >
                    {group.name}
                  </Button>
                ))}
              </div>
            </div>
          </div>
        )}
        
        <div>
          <Label htmlFor="period">Dövr</Label>
          <Select value={period} onValueChange={setPeriod}>
            <SelectTrigger className="mt-1.5" data-testid="period-select">
              <SelectValue placeholder="Dövr seçin" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="today">Bu Gün</SelectItem>
              <SelectItem value="yesterday">Dünən</SelectItem>
              <SelectItem value="last_7_days">Son 7 Gün</SelectItem>
              <SelectItem value="last_30_days">Son 30 Gün</SelectItem>
              <SelectItem value="current_month">Cari Ay</SelectItem>
              <SelectItem value="last_month">Keçən Ay</SelectItem>
              <SelectItem value="custom">Xüsusi Tarix</SelectItem>
            </SelectContent>
          </Select>
        </div>
        
        {period === 'custom' ? (
          <>
            <div>
              <Label htmlFor="start_date">Başlanğıc tarixi</Label>
              <Input
                id="start_date"
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className="mt-1.5"
                data-testid="start-date-input"
              />
            </div>
            <div>
              <Label htmlFor="end_date">Bitmə tarixi</Label>
              <Input
                id="end_date"
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                className="mt-1.5"
                data-testid="end-date-input"
              />
            </div>
          </>
        ) : (
          <>
            <div>
              <Label htmlFor="start_date_display">Başlanğıc tarixi</Label>
              <Input
                id="start_date_display"
                type="text"
                value={displayDateRange.split(' - ')[0] || ''}
                disabled
                className="mt-1.5 bg-zinc-50"
              />
            </div>
            <div>
              <Label htmlFor="end_date_display">Bitmə tarixi</Label>
              <Input
                id="end_date_display"
                type="text"
                value={displayDateRange.split(' - ')[1] || ''}
                disabled
                className="mt-1.5 bg-zinc-50"
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default StatisticsFilters;
